import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage/HomePage';
import LoginPage from '../pages/LoginPage/LoginPage';
import NotFoundPage from '../pages/NotFoundPage';
import ExamResults from '../pages/ExamResults/ExamResults';
import SettingsPage from '../pages/SettingsPage/SettingsPage';
import RegistrationPage from '../pages/RegistrationPage/RegistrationPage';
import FirstTimeLoginPage from '../pages/FirstTimeLoginPage/FirstTimeLoginPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage/ForgotPasswordPage';
import ResetPasswordPage from '../pages/ResetPasswordPage/ResetPasswordPage';
import TakeExam from '../pages/TakeExam/TakeExam';
import CheckExamPage from '../pages/CheckExamPage/CheckExamPage';
import TakeExamSplash from '../pages/TakeExamSplash/TakeExamSplash';
import TermsPage from '../pages/TermsPage/TermsPage';
import PrivacyPage from '../pages/PrivacyPage/PrivacyPage';

const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/exam/:examId" element={<TakeExam />} />
            <Route path="/exam/:examAttemptId/submit" element={<TakeExamSplash />} />
            <Route path="/exam/:examAttemptId/view" element={<CheckExamPage />} />
            <Route path="/results" element={<ExamResults />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/setup" element={<FirstTimeLoginPage />} />
            <Route path="/register" element={<RegistrationPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/preboard/password/reset" element={<ResetPasswordPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default AppRoutes;